(function ($) {
  var slickVarsMobile = {
    arrows: false,
    dots: false,
    slidesToShow: 1.8,
    slidesToScroll: 1.8,
  };

  var slickVarsDesktop = {
    arrows: false,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
  };

  var width = $(window).width();
  if (width < 1025) {
    $('.product-carousel__list').slick(slickVarsMobile);
  } else {
    $('.product-carousel__list').slick(slickVarsDesktop);
  }

  $('.product-carousel__control').on('click', function () {
    var slider = $(this).parents('.product-carousel').find('.slick-slider');
    slider.slick('slickNext');
  });

  $(window).on('resize', function () {
    var width = $(window).width();
    $('.product-carousel__list').slick('unslick');
    if (width < 1025) {
      return $('.product-carousel__list').slick(slickVarsMobile);
    } else {
      return $('.product-carousel__list').slick(slickVarsDesktop);
    }
  });
})(jQuery);
